import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-vue-app-with-vue-i18n
function loadLocaleMessages() {
  const locales = require.context(
    `@/locales/${process.env.VUE_APP_DEVICE}`,
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};

  // ['./en.json', './ko.json']
  locales.keys().forEach((path) => {
    const matched = path.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(path);
    }
  });

  console.log('!!!!! $t', messages);
  return messages;
}

export default new VueI18n({
  locale               : process.env.VUE_APP_I18N_LOCALE || 'ko',
  fallbackLocale       : process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ko',
  messages             : loadLocaleMessages(),
  silentTranslationWarn: true // [vue-i18n] Value of key 'xxxx' is not a string! 경고 무시
});
